export const getFacilityNextStates = (documentId, state) => {
  const item = state.facilities.facilityNextStates[documentId];
  const loaded = item && item.loaded ? true : false;
  const loading = item && item.loading ? true : false;
  const content = item && item.loaded ? Object.values(state.facilities.facilityNextStates[documentId].nextStates) : [];

  return { loading, loaded, content };
};
